import script from "./Nav.vue?vue&type=script&setup=true&lang=js"
export * from "./Nav.vue?vue&type=script&setup=true&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=6affaa7b&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6affaa7b"]])

export default __exports__